import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Routes, RouterModule } from '@angular/router';

import { SharedModule } from '../shared/shared.module';
import { AuthenticationComponent } from './authentication.component';

const routes: Routes = [
  {
    path: '',
    component: AuthenticationComponent,
  },
];

@NgModule({
  declarations: [AuthenticationComponent],
  imports: [CommonModule, SharedModule, RouterModule.forChild(routes)],
})
export class AuthenticationModule {}
